import React from 'react';
import { enhance } from './lib/dynamicStore';
import './App.css';
import Switcher from './Switcher';

const App = () => (
  <div>
    <Switcher />
  </div>
);

export default enhance(App, {
  key: 'app',
});
